module.exports = "<rkc-header></rkc-header> <div layout=row flex> <rkc-sidebar></rkc-sidebar> <div flex role=main class=allow-overflow> <div flex ui-view></div> </div> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/main/main.html
 ** module id = 483
 ** module chunks = 0
 **/